export default "__VITE_ASSET__CGGNjKyV__"